import { useState } from "react"

export function ConfirmButton({label, onClick, className}) {
    const [isConfirm, setIsConfirm] = useState(false)

    const handleClick = () => {
        setIsConfirm(false)
        onClick()
    }

    return(<div className="flex gap-xs">
        {!isConfirm && <button className={`showing ${className ? className : 'outline'}`} onClick={() => setIsConfirm(true)}>{label}</button>}
        {isConfirm && <div className="flex gap-xs center radius" style={{backgroundColor: 'rgba(var(--neutral), 30%)', padding: '3px'}}>
            <button className="solid-error showing" onClick={handleClick}>Confirm</button>
            <button className="outline showing" onClick={() => setIsConfirm(false)}>Cancel</button>
        </div>}
    </div>)
}